import React, { useEffect, useState } from 'react';
import {Helmet} from "react-helmet";
import {PERSONAL_DATA_FORM_FIELDS_NAMES} from "../../reducers/personalDataForm";
import {SUPPLY_ADDRESS_FORM_FIELD_NAMES} from "../../reducers/supplyAddressForm";
import Md5 from "crypto-js/md5";

let env_work
let tag_container

const domain = window.location.host

if (domain == 'funnel.vivigas.it'){
    env_work = 'prod'
    tag_container = 'https://cdn.tagcommander.com/5326/tc_Vivigas_21.js'
}
else{
    env_work = 'preprod'
    tag_container = 'https://cdn.tagcommander.com/5326/uat/tc_Vivigas_21.js'
}
const tagContainer = tag_container


function loadContainer(){
        let random;
        let pathkey = sessionStorage.getItem(window.location.pathname);
        if(!pathkey){
            random = Math.random().toString(36).substring(7)
            sessionStorage.setItem(window.location.pathname, random)
        }else{
            random = pathkey;
        }

        const asc = {
            "src": `${tagContainer}?cachebuster=${random}`,
            'id': 'loadContainer'
        }
        return(asc)
}
function getCookie(nome) {
    var name = nome + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "t";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "m";
    }
    return "d";
};
export  const DataLayerContainerHome =() => {


   //loadContainer();
   const VivigasUId = getCookie('VivigasUId');

   return(
    <div className="application">
        <Helmet>
            <title>Vivigas Registrazione</title>
            <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_basket", 
                    env_device: "${getDeviceType()}",
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Registrazione",
                    user_id:"${VivigasUId}"
                }//]]>       
                `}</script>
            <script {...loadContainer()} />
        </Helmet>
    </div>)
};

export  const DataLayerContainerPersonalData = ({ offer }) => {

    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (offer.name.includes('LuceG')){
        type = 'dual'
    }
    if (offer.name.includes('Luce') && (!offer.name.includes('LuceG'))){
        type = 'luce'
    }
    if (offer.name.includes('Gas') && (!offer.name.includes('LuceG'))){
        type = 'gas'
    }
    const commodity = type

    return(
        <div className="application">
            <Helmet>
                <title>Vivigas - Dati Personali</title>

                <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_step2", 
                    env_device: "${getDeviceType()}",
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Dati Personali", 
                    product_array : [{
                         product_id : "${offer.offerId}", //prod id
                         product_name : "${offer.name}", //name
                         product_price : "",
                         product_commodity : "${commodity}", //commodity_type //luce o gas
                         product_business_type : "Private", //business_type
                         product_option: "${offer.offerType}", //mono or bio
                      }],
                    user_id:"${VivigasUId}"
               }//]]>       
                `}</script>
                <script {...loadContainer()} />
            </Helmet>
        </div>)
};

export  const DataLayerContainerSupply  = ({ offer }) => {
    //console.log(JSON.stringify(offer))
    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (offer.name.includes('LuceG')){
        type = 'dual'
    }
    if (offer.name.includes('Luce') && (!offer.name.includes('LuceG'))){
        type = 'luce'
    }
    if (offer.name.includes('Gas') && (!offer.name.includes('LuceG'))){
        type = 'gas'
    }
    const commodity = type

    return(
        <div className="application">
            <Helmet>
                <title>Vivigas - Indirizzo fornitura </title>

                <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_step3", 
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Indirizzo fornitura", 
                    product_array : [{
                         product_id : "${offer.offerId}", //prod id
                         product_name : "${offer.name}", //name
                         product_price : "",
                         product_commodity : "${commodity}", //commodity_type //luce o gas
                         product_business_type : "Private", //business_type
                         product_option: "${offer.offerType}", //mono or bio
                         }],
                         user_id:"${VivigasUId}"
                    }//]]>       
                `}</script>
                <script {...loadContainer()} />
            </Helmet>
        </div>)
};

export  const DataLayerContainerPaymentRecap  = ({ offer }) => {
    //console.log(JSON.stringify(offer))
    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (offer.name.includes('LuceG')){
        type = 'dual'
    }
    if (offer.name.includes('Luce') && (!offer.name.includes('LuceG'))){
        type = 'luce'
    }
    if (offer.name.includes('Gas') && (!offer.name.includes('LuceG'))){
        type = 'gas'
    }
    const commodity = type

    return(
        <div className="application">
            <Helmet>
                <title>Vivigas - Recapito Pagamento </title>
                <script {...loadContainer()} />
                <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_step4", 
                     env_device: "${getDeviceType()}",
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Recapito Pagamento", 
                    product_array : [{
                         product_id : "${offer.offerId}", //prod id
                         product_name : "${offer.name}", //name
                         product_price : "",
                         product_commodity : "${commodity}", //commodity_type //luce o gas
                         product_business_type : "Private", //business_type
                         product_option: "${offer.offerType}", //mono or bio
                      }],
                      user_id:"${VivigasUId}"
               }//]]>       
                `}</script>
            </Helmet>
        </div>)
};
export  const DataLayerContainerConsent = ({ offer }) => {

    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (offer.name.includes('LuceG')){
        type = 'dual'
    }
    if (offer.name.includes('Luce') && (!offer.name.includes('LuceG'))){
        type = 'luce'
    }
    if (offer.name.includes('Gas') && (!offer.name.includes('LuceG'))){
        type = 'gas'
    }
    const commodity = type
    return(
        <div className="application">
            <Helmet>
                <title>Vivigas - Consensi</title>
                <script {...loadContainer()}  />
                <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_step5", 
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Consensi", 
                    product_array : [{
                         product_id : "${offer.offerId}", //prod id
                         product_name : "${offer.name}", //name
                         product_price : "",
                         product_commodity : "${commodity}", //commodity_type //luce o gas
                         product_business_type : "Private", //business_type
                         product_option: "${offer.offerType}", //mono or bio
                      }],
                      user_id:"${VivigasUId}"
               }//]]>       
                `}</script>
            </Helmet>
        </div>)
};
export  const DataLayerContainerRecap = ({ offer }) => {
    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (offer.name.includes('LuceG')){
        type = 'dual'
    }
    if (offer.name.includes('Luce') && (!offer.name.includes('LuceG'))){
        type = 'luce'
    }
    if (offer.name.includes('Gas') && (!offer.name.includes('LuceG'))){
        type = 'gas'
    }
    const commodity = type
    return(
        <div className="application">
            <Helmet>
                <title>Vivigas - Riepilogo</title>
                <script type="text/javascript">{`
             //<![CDATA[
                var tc_vars = {
                    env_template : "funnel_step6", 
                    env_device: "${getDeviceType()}",
                    env_work : "${env_work}", 
                    env_language : "IT",  
                    page_level1 : "funnel_basket", 
                    page_name : "Vivigas - Riepilogo", 
                    product_array : [{
                         product_id : "${offer.offerId}", //prod id
                         product_name : "${offer.name}", //name
                         product_price : "",
                         product_commodity : "${commodity}", //commodity_type //luce o gas
                         product_business_type : "Private", //business_type
                         product_option: "${offer.offerType}", //mono or bio
                      }],
                      user_id:"${VivigasUId}"
               }//]]>       
                `}</script>

                <script {...loadContainer()} />
            </Helmet>
        </div>)
};
export  const DataLayerContainerEndPage = (props) => {
    const VivigasUId = getCookie('VivigasUId');
    //alert (VivigasUId);
    let type= ''
    if (props.name.includes('LuceG')){
        type = 'dual'
    }
    if (props.name.includes('Luce') && (!props.name.includes('LuceG'))){
        type = 'luce'
    }
    if (props.name.includes('Gas') && (!props.name.includes('LuceG'))){
        type = 'gas'
    }
    const Commodity = type

    let uso
    if(props.usoGasCucina){
        uso = 'Gas Cucina '
    }
    if(props.usoGasAcquaCalda){
        uso += 'Acqua Calda '
    }
    if(props.usoGasRiscaldamento){
        uso += 'Riscaldamento'
    }
    const useCategory = uso
    const hashedPhones = props.cellulare
    let HashedPhonesMD5 = ''
    if (hashedPhones.length > 3 ){
         HashedPhonesMD5 = Md5(hashedPhones).toString()
    }
    return(
        <div className="application">
            <Helmet>

                <title>Vivigas - Conferma </title>
            <script type="text/javascript">{`
                     //<![CDATA[
                        var tc_vars = {
                            env_template : "funnel_typ", 
                            env_device: "${getDeviceType()}",
                            env_work : "${env_work}", 
                            env_language : "IT",  
                            page_level1 : "funnel_basket", 
                            page_name : "Vivigas - Conferma", 
                            order_id: "${props.userId}",
                            order_value: "${Commodity}",
                            contract_type: "voltura",
                            user_gas_provider: "${props.attualeFornitoreGas}",
                            use_category:"${useCategory}",
                            user_ele_provider:"${props.attualeFornitoreLuce}",
                            user_ele_consumption:"${props.consumoLuce}",
                            user_residency:"${props.indirizzoRecapitoCoincideConFornitura}",
                            ele_power:"",
                            product_array : [{
                                  product_id : "${props.offerId}", //prod id
                                  product_name : "${props.name}", //name
                                  product_price : "",
                                  product_commodity : "${Commodity}", //commodity_type //luce o gas
                                  product_business_type : "Private", //business_type
                                  product_option: "${props.offerType}", //mono or bio
                              }],
                            user_id:"${VivigasUId}",
                            user_firstname:"${props.nome}",
                            user_lastname:"${props.cognome}",
                            user_email:"${props.emailConfirmation}",
                            user_phone:"${props.cellulare}",
                            user_gender:"${props.gender}",
                            user_fiscal_code:"${props.codiceFiscale}",
                            user_city:"${props.city}",
                            user_postalcode:"${props.cap}",
                            business_type:"Private",
                            commodity_type:"${Commodity}",
                            user_consent_postal:"${props.marketingPosta}",
                            user_consent_phone:"${props.marketingTelefono}",
                            user_consent_email:"${props.marketingEmail}",
                            user_consent_mkres:"${props.marketingElaborazione}"                            
                       }//]]>       
                        `}</script>
                <script {...loadContainer()} />
        </Helmet>
        </div>
)
};